<template>
  <div>
    <ul class="table-list">
      <li
        v-for="(item, index) of moduleData.data"
        :key="index"
        :class="{'top-border': index === 0}"
      >
        <div
          class="blue-bar"
          :style="{ width: setWidth(item.DataValue) + '%'}"
        >
          <span class="data-name">{{ $format.string(item.SubTypeName) }}
            <slot
              v-if="$format.string(item.SubTypeName) === 'Cash & equivalents'"
              name="superscript1"
            />
          </span>
        </div>
        <div
          v-if="moduleData.includeDataField"
          class="data-value strong pull-right"
        >
          {{ $format.rawPercent(item.DataValue, 1) }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
	name: 'BlueBarTable',
	props: {
		moduleData: {
			type: Object,
			default() {
				return {
					data: [],
					includeDataField: false
				};
			}
		}
	},
	methods: {
		setMaxValue(array) {
			let highest = 0;
			array.forEach(item => {
				if (typeof item.DataValue === 'string') {
					item.DataValue = parseFloat(item.DataValue);
				}
				if (item.DataValue > highest) {
					highest = item.DataValue;
				}
			});
			return highest;
		},
		setWidth(value) {
			const maxValue = this.setMaxValue(this.moduleData.data) || 0;
			let width = 0;
			if (value && maxValue !== undefined && maxValue !== 0) {
				width = value / maxValue * 80;
			}
			return width;
		}
	}
};
</script>

<style lang="less" scoped>
	.table-list {
		font-family: 'AvenirNextLTW01-Regular', Arial, serif;
		list-style-type: none;
		margin: auto;
		padding: 0;
		li {
			border-bottom: 1px solid #ccc;
			display: inline-block;
			line-height: 22px;
			padding-right: 10px;
			width: 100%;
			margin-bottom: 0;
		}
		.top-border {
			border-top: 1px solid #ccc;
			height: 23px;
		}
		.blue-bar {
			background-color: #f2fafd;
			display:inline-block;
			height: 21px;
			padding-left: 10px;
			white-space: nowrap;
		}
	}
	.sub-info {
		margin-top: 10px;
	}

</style>

